import { useEffect } from 'react'

import { User } from '~/hooks/useAuthentication/types'

import { UserRole } from '~/__generated_types__/globalTypes'

const useSprigTracking = (user: User | null | undefined) => {
  useEffect(() => {
    if (!user) return

    if (!process.env.NEXT_PUBLIC_SPRIG_ENVIRONMENT_ID) {
      console.error('Call from layout: Sprig environment ID is not set')

      return
    }

    try {
      window.Sprig('setUserId', user.uuid)
      window.Sprig('setAttributes', {
        USER_ROLE: user.role,
        USER_EMAIL: user.email,
        ...(user.role === UserRole.Customer &&
          user.customer && {
            CUSTOMER_NAME: user.customer.name,
            CUSTOMER_TYPE: user.customer.type,
          }),
      })
    } catch (error) {
      console.error('Failed to initialize Sprig tracking:', error)
    }
  }, [user])
}

export default useSprigTracking
